<script>
import DatePicker from 'vue3-persian-datetime-picker'

import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import animationData from "@/components/widgets/msoeawqm.json";
import animationData1 from "@/components/widgets/gsqxdxog.json";
import Lottie from "@/components/widgets/lottie.vue";
import UserService from "@/services/user.service";

export default {
    page: {
        title: "مشتریان",
    },
    data() {
        return {
            title: "مشتریان",
            searchQuery: null,
            defaultOptions: {
                animationData: animationData
            },
            defaultOptions2: {
                animationData: animationData1
            },
            page: 1,
            perPage: 8,
            value: null,
            pages: [],
            customerList: [],
            searchCustomerKey: '',
            isSearching: false,
            fname: '',
            lname: '',
            phone: '',
            email: '',
            birthdate: '',
            newCustomerLoading: false,
        };
    },
    computed: {
        displayedPosts() {
            return this.paginate(this.customerList);
        },
        resultQuery() {
            if (this.searchQuery) {
                const search = this.searchQuery.toLowerCase();
                return this.displayedPosts.filter((data) => {
                    return (
                        data.customer.toLowerCase().includes(search) ||
                        data.email.toLowerCase().includes(search) ||
                        data.phone.includes(search) ||
                        data.date.toLowerCase().includes(search) ||
                        data.status.toLowerCase().includes(search)
                    );
                });
            } else {
                return this.displayedPosts;
            }
        },
    },
    watch: {
        searchCustomerKey: function () {
            this.phone = this.searchCustomerKey;
        }
    },
    created() {
        this.setPages();
    },
    filters: {
        trimWords(value) {
            return value.split(" ").splice(0, 20).join(" ") + "...";
        },
    },

    methods: {
        searchCustomer() {
            this.isSearching = true;
            return UserService.BranchCustomerSearch({key: this.searchCustomerKey})
                .then((response) => {
                const {data} = response;
                this.customerList = data;
            }).catch(() => {
                // this.$Progress.fail();
            }).then(() => {
                this.isSearching = false;
            });
        },
        editdata(data) {
            let result = this.customerList.findIndex(
                (o) => o.customerId == data.customerId
            );
            document.getElementById("edtidfield1").value =
                this.customerList[result]._id;
            document.getElementById("edtcustomername").value =
                this.customerList[result].customer;
            document.getElementById("edtemail").value =
                this.customerList[result].email;
            document.getElementById("edtphone").value =
                this.customerList[result].phone;
            document.getElementById("edtjoindate").value =
                this.customerList[result].date;
            document.getElementById("edtstatusfield").value =
                this.customerList[result].status;
        },
        createUser() {
            this.newCustomerLoading = true;
            let has_error = false;
            if (!this.fname.length) {
                has_error = true;
                this.$notify({
                    title: 'خطا',
                    text: 'نام مشتری وارد نشده است.',
                    type: 'error',
                });
            }
            if (!this.lname.length) {
                has_error = true;
                this.$notify({
                    title: 'خطا',
                    text: 'نام خانوادگی مشتری وارد نشده است.',
                    type: 'error',
                });
            }
            if (!this.phone.length) {
                has_error = true;
                this.$notify({
                    title: 'خطا',
                    text: 'شماره مشتری وارد نشده است.',
                    type: 'error',
                });
            }
            if (has_error) {
                this.newCustomerLoading = false;
                return false;
            }
            return new Promise((resolve) => {
                return UserService.BranchCustomerCreate({
                    firstName: this.fname,
                    lastName: this.lname,
                    phone: this.phone,
                    email: this.email,
                    birthdate: this.birthdate,
                })
                    .then((response) => {
                        resolve(response);
                        if(response.status === 200) {
                            let user_id = response.data?.users?.[0]?.id;
                            if (!user_id) {
                                this.newCustomerLoading = false;
                                this.$notify({
                                    title: 'خطا',
                                    text: 'شناسه کاربر ساخته‌شده دریافت نشد.',
                                    type: 'error',
                                });
                                return;
                            }
                            this.$notify({
                                title: 'کاربر با موفقیت ساخته شد.',
                                type: 'success',
                            });
                            // jQuery('createCustomerModal').modal('hide');
                            this.$refs.closeCreateUserModal.click();
                            this.$router.push({name: 'user-profile', params: {user_id: user_id}});
                        }
                    }, (error) => {
                        this.newCustomerLoading = false;
                        this.$notify({
                            title: "خطا",
                            text: error.response?.data?.message || error.message,
                            type: 'error',
                        });
                    })
            });
        },
        setPages() {
            let numberOfPages = Math.ceil(this.customerList.length / this.perPage);
            for (let index = 1; index <= numberOfPages; index++) {
                this.pages.push(index);
            }
        },
        paginate(customerList) {
            let page = this.page;
            let perPage = this.perPage;
            let from = page * perPage - perPage;
            let to = page * perPage;
            return customerList.slice(from, to);
        },
    },
    mounted() {
        var checkAll = document.getElementById("checkAll");
        if (checkAll) {
            checkAll.onclick = function () {
                var checkboxes = document.querySelectorAll(
                    '.form-check-all input[type="checkbox"]'
                );
                if (checkAll.checked == true) {
                    checkboxes.forEach(function (checkbox) {
                        checkbox.checked = true;
                        checkbox.closest("tr").classList.add("table-active");
                    });
                } else {
                    checkboxes.forEach(function (checkbox) {
                        checkbox.checked = false;
                        checkbox.closest("tr").classList.remove("table-active");
                    });
                }
            };
        }
    },
    components: {
        Layout,
        Lottie,
        PageHeader,
        DatePicker
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card" id="customerList">
                    <div class="card-header border-bottom-dashed">
                        <div class="row g-4 align-items-center">
                            <div class="col-sm">
                                <div>
                                    <h5 class="card-title mb-0">مشتریان</h5>
                                </div>
                            </div>
                            <div class="col-sm-auto">
                                <div>
                                    <button type="button" class="btn btn-success add-btn me-1" data-bs-toggle="modal"
                                        id="create-btn" data-bs-target="#createCustomerModal">
                                        <i class="ri-add-line align-bottom me-1"></i> اضافه کردن مشتری جدید
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body border-bottom-dashed border-bottom">
                        <form @submit.prevent="searchCustomer">
                            <div class="row g-3">
                                <div class="col-xl-6">
                                    <div class="search-box">
                                        <input v-model="searchCustomerKey" type="text" class="form-control search"
                                            placeholder="شماره همراه مشتری را وارد کنید." />
                                        <i class="ri-search-line search-icon"></i>
                                    </div>
                                </div>
                                <!--end col-->
                                <div class="col-xl-6">
                                    <div class="row g-3">
                                        <div class="col-sm-4">
                                            <div>
                                                <button type="submit" class="btn btn-primary w-100">
                                                    <i class="ri-equalizer-fill me-2 align-bottom"></i>
                                                    جستجو
                                                </button>
                                            </div>
                                        </div>
                                        <!--end col-->
                                    </div>
                                </div>
                            </div>
                            <!--end row-->
                        </form>
                        <div class="panel-spinner-overlay" v-if="isSearching">
                            <b-spinner variant="warning"></b-spinner>
                        </div>
                    </div>

                    <div class="card-body" v-if="customerList.length">
                        <div>
                            <div class="table-responsive table-card mb-1">
                                <table class="table align-middle" id="customerTable">
                                    <thead class="table-light text-muted">
                                        <tr>
                                            <th scope="col" style="width: 50px">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" id="checkAll"
                                                        value="option" />
                                                </div>
                                            </th>

                                            <th class="sort" data-sort="customer_name">نام مشتری</th>
                                            <th class="sort" data-sort="email">ایمیل</th>
                                            <th class="sort" data-sort="phone">شماره همراه</th>
                                            <th class="sort" data-sort="action">عملیات</th>
                                        </tr>
                                    </thead>
                                    <tbody class="list form-check-all">
                                        <tr v-for="(item, index) of resultQuery" :key="index">
                                            <th scope="row">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" name="chk_child"
                                                        value="option1" />
                                                </div>
                                            </th>
                                            <td class="id" style="display: none">
                                                <a href="javascript:void(0);" class="fw-medium link-primary">{{
                                                    item.customerId }}</a>
                                            </td>
                                            <td class="customer_name">{{ item.customer }}</td>
                                            <td class="email">{{ item.email }}</td>
                                            <td class="phone">{{ item.phone }}</td>
                                            <td>
                                                <ul class="list-inline hstack gap-2 mb-0">
                                                    <li v-if="false" class="list-inline-item edit"
                                                        data-bs-toggle="tooltip" data-bs-trigger="hover"
                                                        data-bs-placement="top" title="Edit">
                                                        <a href="#editmodal" data-bs-toggle="modal"
                                                            class="text-primary d-inline-block edit-item-btn"
                                                            @click="editdata(item)">
                                                            <i class="ri-pencil-fill fs-16"></i>
                                                            <span>ویرایش پروفایل</span>
                                                        </a>
                                                    </li>
                                                    <li class="list-inline-item show">
                                                        <router-link
                                                            :to="{name: 'user-profile', params: {user_id: item.id}}"
                                                            class="fw-medium link-primary">
                                                            <i class="ri-pencil-fill fs-16"></i>
                                                            مشاهده پروفایل
                                                        </router-link>

                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="noresult" style="display: none">
                                    <div class="text-center">
                                        <lottie class="avatar-xl" colors="primary:#121331,secondary:#08a88a"
                                            :options="defaultOptions" :height="75" :width="75" />
                                        <h5 class="mt-2">Sorry! No Result Found</h5>
                                        <p class="text-muted mb-0">
                                            We've searched more than 150+ customer We did not find any
                                            customer for you search.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->
        </div>

        <div class="modal fade" id="editmodal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header bg-light p-3">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Update Customer
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            id="close-modal"></button>
                    </div>
                    <form action="#" id="addform">
                        <div class="modal-body">
                            <input type="hidden" id="id-field" />

                            <div class="mb-3" id="modal-id" style="display: none">
                                <label for="id-field1" class="form-label">ID</label>
                                <input type="text" id="edtidfield1" class="form-control" placeholder="ID" readonly />
                            </div>

                            <div class="mb-3">
                                <label for="customername-field" class="form-label">Customer Name</label>
                                <input type="text" id="edtcustomername" class="form-control" placeholder="Enter Name"
                                    required />
                            </div>

                            <div class="mb-3">
                                <label for="email-field" class="form-label">Email</label>
                                <input type="email" id="edtemail" class="form-control" placeholder="Enter Email"
                                    required />
                            </div>

                            <div class="mb-3">
                                <label for="phone-field" class="form-label">Phone</label>
                                <input type="text" id="edtphone" class="form-control" placeholder="Enter Phone no."
                                    required />
                            </div>

                            <div class="mb-3">
                                <label for="date-field" class="form-label">Joining Date</label>
                                <date-picker v-model="birthdate" format="YYYY/MM/DD"></date-picker>
                            </div>
                            <div>
                                <label for="status-field" class="form-label">Status</label>
                                <select class="form-control" data-trigger id="edtstatusfield">
                                    <option value="">Status</option>
                                    <option value="Active">Active</option>
                                    <option value="Block">Block</option>
                                </select>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div class="hstack gap-2 justify-content-end">
                                <button type="button" id="edtclosemodal" class="btn btn-light" data-bs-dismiss="modal">
                                    Close
                                </button>
                                <button type="button" class="btn btn-success" @click="updatedata">
                                    Update
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="modal fade" id="createCustomerModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered new-customer-modal">
                <div class="modal-content">
                    <div class="modal-header d-flex align-items-center justify-content-between bg-light p-3">
                        <h5 class="modal-title" id="exampleModalLabel">مشتری جدید</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"></button>
                    </div>
                    <form action="#">
                        <div class="modal-body">
                            <div class="mb-3">
                                <div class="row">
                                    <div class="col-6">
                                        <label for="fname-field" class="form-label">نام</label>
                                        <input type="text" id="fname-field" v-model="fname" class="form-control" placeholder="نام را وارد کنید." required />
                                    </div>
                                    <div class="col-6">
                                        <label for="lname-field" class="form-label">نام خانوادگی</label>
                                        <input type="text" id="lname-field" v-model="lname" class="form-control" placeholder="نام خانوادگی را وارد کنید." required />
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label for="phone-field" class="form-label">شماره تماس</label>
                                <input type="text" id="phone" v-model="phone" class="form-control" placeholder="شماره تماس مشتری را وارد کنید." required />
                            </div>

                            <div class="mb-3">
                                <label for="email-field" class="form-label">ایمیل</label>
                                <input type="email" v-model="email" id="email" class="form-control" placeholder="ایمیل مشتری" />
                            </div>

                            <div class="mb-3">
                                <label for="birthdate" class="form-label">تاریخ تولد</label>
                                <date-picker v-model="birthdate" locale="fa,en" format="YYYY/M/D" displayFormat="jYYYY/jMM/jDD">
                                </date-picker>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div class="hstack gap-2 justify-content-end">
                                <button type="button" id="closemodal" class="btn btn-light" data-bs-dismiss="modal" ref="closeCreateUserModal">لغو</button>
                                <button type="button" class="btn btn-success" @click="createUser">افزودن</button>
                            </div>
                        </div>

                        <div class="panel-spinner-overlay" v-if="newCustomerLoading">
                            <b-spinner variant="warning"></b-spinner>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!--end row-->
    </Layout>
</template>
